import { OutlineButton } from "Components/HomeV2/Buttons";
import YouTubeEmbed from "Components/YoutubeEmbed/YouTubeEmbed";
import { useState } from "react";
import image from "../../Assets/AIOnDemand/proven-expertise.png";

const ProvenB2BExperience = () => {
    const [showOverlay, setShowOverlay] = useState(false);

    return (
        <section className="bg-gradient-to-r from-[#CBEFE9] to-[#5E74B4] pt-5 lg:pt-16 mb-3  lg:mb-10">
            <div className="flex flex-col max-w-[1400px] gap-10 mx-auto">
                <div className="flex flex-col gap-4 text-center mx-auto text-black">
                    <h2 className="text-3xl lg:text-5xl text-black ">Proven B2B Sales & Marketing Expertise</h2>
                    <p className="text-md lg:text-xl">Over 350 Sales Pipelines Supercharged</p>
                    <button onClick={() => setShowOverlay(true)} className="w-fit mx-auto flex items-center justify-center ">
                        <OutlineButton theme="black">Watch Video</OutlineButton>
                    </button>
                </div>
                <img src={image} alt="salesmrkt clients" className="object-contain w-full h-auto" />
            </div>
            {showOverlay && (
                <div>
                    {
                        <YouTubeEmbed
                            videoId={"XCB8y8idJvE?si=vWQ7c4UxNJegyjDN"}
                            onClose={() => setShowOverlay(false)}
                        />
                    }
                </div>
            )}
        </section>
    );
}

export default ProvenB2BExperience;